import React, {Component} from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import InlineTable from "../../components/InlineTable";
import {formatSubscriptionStatus} from "../../lib/SubscriptionStatus";
import {connect} from "react-redux";
import {graphql} from "react-apollo";
import gql from "graphql-tag";

const FIELDS = fromJS([
  { field: "quantity", title: "Qty." },
  { field: "productSku", title: "Product" },
  { field: "productTitle", title: "Title"}
])

class SubscriptionInfoPanel extends Component {

  componentDidMount() {
    if (this.props.subscriptionId) {
      this.subscribe(this.props);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.subscriptionId && (prevProps.subscriptionId !== this.props.subscriptionId)) {
      this.subscribe(this.props);
    }
  }

  componentWillUnmount() {
    this.unsubscribe(); 
  }  

  subscribe(props) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToMore(props, {});
  }  

  render() {
    let elements = null;
    if (!this.props.subscriptionId || this.props.subscriptionId === "") {
      elements = <p className="u-no-selection">Nothing selected</p>
    } else {
      let properties = fromJS([
        {prop: "subscriptionId", label: "Id", type: "subscriptionId"},
        {prop: "accountId", label: "Account", type: "accountId"},
        {prop: "currentSeqId", label: "Seq. Id", type: "number"},
        {prop: "name", label: "Name", type: "string"},
        {prop: "frequencyWeeks", label: "Freq. Weeks", type: "number"},
        {prop: "subscribedAt", label: "Subscribed At", type: "utc"},
        {prop: "wasImported", label: "Imported", type: "boolean"},
        {prop: "status", label: "Status", type: "fn", fn: (data) => {
          return [formatSubscriptionStatus(data), "string"];
        }},
        {prop: "nextDeliveryDate", label: "Next Est. Delivery", type: "fn", fn: (data) => {
          if (data.get("hasEstimatedDeliveryDate") === true) return [data.get("nextEstimatedDeliveryDate"), "date"];
          return ["Unknown", "string"];
        }},
        {prop: "shippingAddress", label: "Address", type: "shippingAddress"},
      ])
  
      let {loading, error, subscriptionInfo} = this.props.data;
      if (loading) return <Loading />
      if (error) return <GraphQLErrors error={error} />
      let imData = fromJS(subscriptionInfo)

      elements = (
        <React.Fragment>
          <PropertiesList properties={properties} data={imData} />
          <br/>
          <InlineTable
            data={imData.get("products")}
            fields={FIELDS}
            dataType="delivery_product"
            />              
        </React.Fragment>
      )
    }

    return (
      <PanelGroupController title="Subscription Info" expanded={this.props.expanded}>
        {elements}
      </PanelGroupController>
    )
  }

}

const SUBSCRIPTION_INFO = gql`
  query subscriptionInfo($subscriptionId:ID!) {
    subscriptionInfo(subscriptionId: $subscriptionId) {
      subscriptionId
      name
      accountId
      frequencyWeeks
      status
      wasImported
      currentSeqId
      subscribedAt
      hasEstimatedDeliveryDate
      nextEstimatedDeliveryDate
      shippingAddress {
        type
        name
        attName
        phoneNr
        email
        addressAddressLine1
        addressAddressLine2
        addressCity
        addressPostcode
        addressStateProvince
        addressCountryCode
        addressCountryName
      }
      products {
        productSku
        productTitle
        quantity
      }
    }
  }  
`;

const ON_UPDATED_SUBSCRIPTION = gql`
  subscription onUpdatedSubscription($subscriptionId:ID!) {
    updatedSubscription(subscriptionId:$subscriptionId) {
      subscriptionId
    }
  }
`

const mapDispatchToProps = dispatch => ({
  subscribeToMore: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_SUBSCRIPTION,
      variables: {
        subscriptionId: props.subscriptionId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withQuery = graphql(SUBSCRIPTION_INFO, {
  skip: (props) => !props.subscriptionId,
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      subscriptionId: props.subscriptionId
    }
  })
})


export default connect(mapDispatchToProps)(withQuery(SubscriptionInfoPanel));